/* eslint-disable */

export function googleTagManager(gtmId) {
  ;(function(w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })
    let f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? `&l=${l}` : ''
    j.async = true
    j.src = `//www.googletagmanager.com/gtm.js?id=${i}${dl}`
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', gtmId)
}

export function pingdom() {
  let s = document.getElementsByTagName('script')[0],
    p = document.createElement('script')
  p.async = 'async'
  p.src = '//rum-static.pingdom.net/prum.min.js'
  s.parentNode.insertBefore(p, s)
  window._prum = [
    ['id', '520a765cabe53d1456000000'],
    ['mark', 'firstbyte', new Date().getTime()],
  ]
}

export function segment(segmentId) {
  var analytics = window.analytics = []; if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice."); else {
    analytics.invoked = !0; analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on"]; analytics.factory = function (t) { return function () { var e = Array.prototype.slice.call(arguments); e.unshift(t); analytics.push(e); return analytics } }; for (var t = 0; t < analytics.methods.length; t++) { var e = analytics.methods[t]; analytics[e] = analytics.factory(e) } analytics.load = function (t, e) { var n = document.createElement("script"); n.type = "text/javascript"; n.async = !0; n.src = "https://cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js"; var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(n, a); analytics._loadOptions = e }; analytics.SNIPPET_VERSION = "4.1.0";
    analytics.load(segmentId);
    analytics.page();
  }
}

/* eslint-enable */
